export class ResgatarBeneficioModel {

    public pessoaGuid: string;
    public cedenteGuid: string;
    public contaGuid: string;
    public valor: number;
    public gestorResponsavelResgateGuid: string;
    public observacao: string;

    constructor() { }
}
